import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import ContactModal from './ContactModal';

/**
 * CallButton — Remplacé par un bouton "Nous contacter" qui ouvre la modale
 * Le numéro de téléphone est conservé uniquement dans le Footer
 */
export default function CallButton({ label = 'Nous contacter', compact = false, className = '', sourcePage = 'Site web' }) {
  const [open, setOpen] = useState(false);

  if (compact) {
    return (
      <>
        <button
          onClick={() => setOpen(true)}
          className={`flex items-center gap-1.5 text-sm font-semibold transition-colors ${className}`}
          style={{ color: 'var(--teal)', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
        >
          <MessageCircle size={15} />
          <span>{label}</span>
        </button>
        <ContactModal open={open} onClose={() => setOpen(false)} sourcePage={sourcePage} />
      </>
    );
  }

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className={`flex items-center gap-2 justify-center px-5 py-3 rounded-xl text-sm font-semibold transition-all ${className}`}
        style={{
          background: '#FFFFFF',
          color: 'var(--ink)',
          border: '1.5px solid var(--border)',
          boxShadow: '0 2px 8px rgba(26,26,46,0.06)',
          cursor: 'pointer',
        }}
      >
        <MessageCircle size={16} style={{ color: 'var(--teal)' }} />
        {label}
      </button>
      <ContactModal open={open} onClose={() => setOpen(false)} sourcePage={sourcePage} />
    </>
  );
}
